


import BasicList from "../../../basic-list";

export default class AcquisitionCategories extends BasicList {

}